<template>
  <legal-document title="Публичная оферта" type="terms" />
</template>

<script>
import LegalDocument from './../../components/legal/LegalDocument';
import InjectsSeo from "@/mixins/InjectsSeo";

export default {
  mixins: [InjectsSeo],

  metaInfo() {
    return {
      title: this.getFullPageTitle('Публичная оферта'),
    }
  },

  components: {
    LegalDocument,
  },
}
</script>
